import { EChartPeriod } from '@aqx-core/common/api/chart/model/types';

import { ICustomBarData } from './chart';
import { EEventMessageType } from './event';

export interface IPostEventPeriodMessage {
  type: typeof EEventMessageType.PERIOD;
  data: {
    chartData: ICustomBarData[];
    period: EChartPeriod;
  };
}

export enum EPeriodGroupKey {
  MINUTES = 'minutes',
  HOURS = 'hours',
  DAYS = 'days'
}
